import moment from 'moment';
// function for creating a dummy incident. This is shown in edit mode to
// populate the incident widgets with some data to show to the user what it will
// look like
const dummyIncident = (skills, dutyFunctions, group) => ({
  dummy: true,
  id: 1,
  created_at: moment().subtract(25, 'minutes').toString(),
  message_to_speech_url: null,
  prio: 'prio1',
  body: 'TEST Lorem ipsum dolor sit amet, consectetur adipiscing elit',
  address: {
    latitude: 52.373_172,
    longitude: 4.892_33,
    formatted_address: 'Dam Square'
  },
  tasks: [],
  stations: [group].filter(Boolean),
  warning_statuses: [
    {
      service_level: 'in_service',
      warning_level: 'below_required',
      available_memberships: [],
      skill_statuses: [
        {
          skill_id: 123,
          level: 'on_required',
          minimum: 1,
          buffer: 0,
          assigned_count: 1,
          available_memberships: []
        },
        {
          skill_id: 124,
          level: 'below_required',
          minimum: 1,
          buffer: 0,
          assigned_count: 0,
          available_memberships: []
        },
        {
          skill_id: 125,
          level: 'above_buffer',
          minimum: 2,
          buffer: 0,
          assigned_count: 4,
          available_memberships: []
        }
      ],
      unchecked_skill_statuses: [],
      availability_requirement: {
        id: 123,
        name: 'TS 987',
        short_code: 'TS 987',
        html_color: '#000000',
        composite: false,
        single_skill_availability_requirements: [
          {
            id: 123,
            skill_id: 123,
            assigned: 1,
            standby: 0
          },
          {
            id: 123,
            skill_id: 123,
            assigned: 1,
            standby: 0
          },
          {
            id: 123,
            skill_id: 123,
            assigned: 2,
            standby: 0
          }
        ],
        // task IDs must overlap with the group in order for the warnings to
        // show in UnderstaffingWarning
        task_ids: group ? group.tasks.map(t => t.id) : [],
        group_ids: [123]
      }
    },
    {
      service_level: 'in_service',
      warning_level: 'below_required',
      available_memberships: [],
      skill_statuses: [
        {
          skill_id: 123,
          level: 'below_required',
          minimum: 2,
          buffer: 0,
          assigned_count: 0,
          available_memberships: []
        }
      ],
      unchecked_skill_statuses: [],
      availability_requirement: {
        id: 124,
        name: 'TS 1234',
        short_code: 'TS 1234',
        html_color: '#000000',
        composite: false,
        external_id: '',
        single_skill_availability_requirements: [
          {
            id: 123,
            skill_id: 123,
            assigned: 1,
            standby: 0
          }
        ],
        task_ids: group ? group.tasks.map(t => t.id) : [],
        group_ids: [123]
      }
    }
  ],
  incident_responses: [
    {
      id: 123,
      incident_id: 1,
      membership_id: (group && group.memberships[0]?.id) || 123,
      display_order: 1,
      group_id: 123,
      user_name: 'Leora Crona',
      user_nickname: 'LC',
      user_photo: {
        present: false,
        url: 'images/missing/users/photos/original/missing.png',
        mini_thumbnail: 'images/missing/users/photos/mini_thumbnail/missing.png',
        medium: 'images/missing/users/photos/medium/missing.png',
        large: 'images/missing/users/photos/large/missing.png'
      },
      location: { latitude: 52.379_045, longitude: 4.895_067 },
      user_id: 123,
      original_rank_id: null,
      performed_rank_id: null,
      assigned_skill_ids: [],
      responded_at: '2024-02-07T00:24:29.357+00:00',
      start_time: '2024-02-07T00:23:42.527+00:00',
      times_overridden: false,
      channel: 'phone_call',
      status: 'acknowledged',
      reported_status: 'shown_up',
      delivery_latency: 20.033_572_112,
      arrived_at_station: false,
      available_at_incident_creation: false,
      group_available_at_incident_creation: true,
      active_duty_function_ids: [dutyFunctions[0]?.id],
      estimated_time_of_arrival: 75,
      on_duty: false,
      alerted_at: '2024-02-07T00:23:42.856+00:00',
      do_not_disturb_at_incident_creation: false
    },
    {
      id: 124,
      incident_id: 1,
      membership_id: (group && group.memberships[1]?.id) || 124,
      display_order: 2,
      group_id: 123,
      user_name: 'Edwin van der Sar',
      user_nickname: 'EvdS',
      user_photo: {
        present: false,
        url: 'images/missing/users/photos/original/missing.png',
        mini_thumbnail: 'images/missing/users/photos/mini_thumbnail/missing.png',
        medium: 'images/missing/users/photos/medium/missing.png',
        large: 'images/missing/users/photos/large/missing.png'
      },
      location: { latitude: 52.391_141, longitude: 4.848_307 },
      user_id: 124,
      original_rank_id: null,
      performed_rank_id: null,
      assigned_skill_ids: [],
      responded_at: '2024-02-07T00:24:29.357+00:00',
      start_time: '2024-02-07T00:23:42.527+00:00',
      times_overridden: false,
      channel: 'phone_call',
      status: 'acknowledged',
      reported_status: 'shown_up',
      delivery_latency: 20.03,
      arrived_at_station: false,
      available_at_incident_creation: true,
      group_available_at_incident_creation: false,
      active_duty_function_ids: [],
      on_duty: false,
      alerted_at: '2024-02-07T00:23:42.856+00:00',
      do_not_disturb_at_incident_creation: true
    },
    {
      id: 125,
      incident_id: 1,
      membership_id: (group && group.memberships[2]?.id) || 125,
      display_order: 2,
      group_id: 123,
      user_name: 'Trent Alexander-Arnold',
      user_nickname: 'TAA',
      user_photo: {
        present: false,
        url: 'images/missing/users/photos/original/missing.png',
        mini_thumbnail: 'images/missing/users/photos/mini_thumbnail/missing.png',
        medium: 'images/missing/users/photos/medium/missing.png',
        large: 'images/missing/users/photos/large/missing.png'
      },
      location: { latitude: 52.370_973, longitude: 4.889_035 },
      user_id: 125,
      original_rank_id: null,
      performed_rank_id: null,
      assigned_skill_ids: [],
      responded_at: '2024-02-07T00:24:29.357+00:00',
      start_time: '2024-02-07T00:23:42.527+00:00',
      times_overridden: false,
      channel: 'phone_call',
      status: 'acknowledged',
      reported_status: 'shown_up',
      delivery_latency: 20.03,
      arrived_at_station: false,
      available_at_incident_creation: true,
      group_available_at_incident_creation: false,
      active_duty_function_ids: [],
      on_duty: false,
      alerted_at: '2024-02-07T00:23:42.856+00:00',
      do_not_disturb_at_incident_creation: false
    },
    {
      id: 126,
      incident_id: 1,
      membership_id: (group && group.memberships[3]?.id) || 126,
      display_order: 4,
      group_id: 123,
      user_name: 'Henry Green',
      user_nickname: 'HG',
      user_photo: {
        present: false,
        url: 'images/missing/users/photos/original/missing.png',
        mini_thumbnail: 'images/missing/users/photos/mini_thumbnail/missing.png',
        medium: 'images/missing/users/photos/medium/missing.png',
        large: 'images/missing/users/photos/large/missing.png'
      },
      user_id: 126,
      original_rank_id: null,
      performed_rank_id: null,
      assigned_skill_ids: [],
      responded_at: null,
      start_time: '2024-02-07T00:23:42.527+00:00',
      times_overridden: false,
      channel: 'unknown',
      status: 'pending',
      reported_status: 'unknown',
      arrived_at_station: null,
      available_at_incident_creation: true,
      active_duty_function_ids: [dutyFunctions[1]?.id],
      on_duty: false,
      alerted_at: '2024-02-07T00:23:42.856+00:00',
      do_not_disturb_at_incident_creation: false
    },
    {
      id: 127,
      incident_id: 1,
      membership_id: 127,
      display_order: 10,
      group_id: 123,
      user_name: 'Sage Daugherty',
      user_nickname: 'SD',
      user_photo: {
        present: false,
        url: 'images/missing/users/photos/original/missing.png',
        mini_thumbnail: 'images/missing/users/photos/mini_thumbnail/missing.png',
        medium: 'images/missing/users/photos/medium/missing.png',
        large: 'images/missing/users/photos/large/missing.png'
      },
      user_id: 127,
      original_rank_id: null,
      performed_rank_id: null,
      assigned_skill_ids: [],
      responded_at: null,
      start_time: '2024-05-15T02:17:51.427+01:00',
      times_overridden: false,
      channel: 'unknown',
      status: 'pending',
      reported_status: 'unknown',
      arrived_at_station: null,
      available_at_incident_creation: false,
      active_duty_function_ids: [],
      on_duty: false,
      alerted_at: '2024-05-15T02:17:51.655+01:00',
      do_not_disturb_at_incident_creation: false
    },
    {
      id: 128,
      incident_id: 1,
      membership_id: 128,
      display_order: 10,
      group_id: 123,
      user_name: 'John Doe',
      user_nickname: 'JD',
      user_photo: {
        present: false,
        url: 'images/missing/users/photos/original/missing.png',
        mini_thumbnail: 'images/missing/users/photos/mini_thumbnail/missing.png',
        medium: 'images/missing/users/photos/medium/missing.png',
        large: 'images/missing/users/photos/large/missing.png'
      },
      user_id: 128,
      original_rank_id: null,
      performed_rank_id: null,
      assigned_skill_ids: [],
      responded_at: null,
      start_time: '2024-05-15T02:17:51.427+01:00',
      times_overridden: false,
      channel: 'unknown',
      status: 'rejected',
      reported_status: 'unknown',
      arrived_at_station: null,
      available_at_incident_creation: false,
      active_duty_function_ids: [],
      on_duty: false,
      alerted_at: '2024-05-15T02:17:51.655+01:00',
      do_not_disturb_at_incident_creation: false
    }
  ],
  radio_channels: ['99'],
  notes: [
    {
      id: 1,
      external_id: '123',
      contents: 'TEST Lorem ipsum dolor sit amet, consectetur adipiscing elit',
      timestamp: moment().subtract(20, 'minutes').toString()
    }
  ],
  incident_skill_assignments: [
    {
      id: 1,
      membership_id: 127,
      incident_id: 1,
      user_id: 127,
      skill_ids: [skills[0]?.id]
    },
    {
      id: 2,
      membership_id: 128,
      incident_id: 1,
      user_id: 128,
      skill_ids: [skills[1]?.id]
    },
    {
      id: 3,
      membership_id: (group && group.memberships[1]?.id) || 125,
      incident_id: 1,
      user_id: 125,
      skill_ids: [skills[1]?.id]
    }
  ]
});

export default dummyIncident;
